import { serviceCreate, merge } from "./modules/request";
//这种方式可以采用单个项目的接口，也可以使用多个项目的接口，看自己的项目情况而定
let http = serviceCreate({
  baseURL: "https://core.kaixinchuichui.cn/admin/index.php",
  timeout: 6000000, //请求超时
  emulateJSON: true //默认表单提交
});

  
  export function getMaterialLibrary(params, config) {
    return http.get("/oaapi/material_library/classList", merge(config, { params }));
  }
  
  export function addMaterialClass(params, config) { 
    return http.post(
    "/oaapi/material_library/classAdd",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function addMaterial(params, config) { 
    return http.post(
    "/oaapi/material_library/material_add",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function delMaterial(params, config) { 
    return http.post(
    "/oaapi/material_library/del_material",
    params,
    merge(config, { emulateJSON: false })
  );
  }
  export function getMaterialPage(params, config) {
    return http.get("/oaapi/material_library/page", merge(config, { params }));
  }

  export function MaterialTitle(params, config) { 
    return http.post(
    "/oaapi/material_library/title",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function getMaterialIds(params, config) {
    return http.get("/oaapi/material_library/id_search", merge(config, { params }));
  }

  
  export function getBannerList(params, config) {
    return http.get("/api/banner/page", merge(config, { params }));
  }

  export function addBanner(params, config) { 
    return http.post(
    "/api/banner/add",
    params,
    merge(config, { emulateJSON: false })
  );
  }
  export function delBanner(params, config) { 
    return http.post(
    "/api/banner/del",
    params,
    merge(config, { emulateJSON: false })
  );
  }

  export function sortBanner(params, config) { 
    return http.post(
    "/api/banner/sort",
    params,
    merge(config, { emulateJSON: false })
  );
  }


// WEBPACK FOOTER //
// ./src/api/aoapi.js